<template>
  <div class="container-fluid full-width-page-wrapper">
    <ifac-loader v-if="busy" />
    <base-error v-else-if="error" />
    <ifac-conference-public-display
      v-else-if="conference"
      :conference="conference"
      :open-committee="openCommittee"
      @committee-change="onCommitteeChange"
    />
  </div>
</template>

<script>
import {
  IfacBaseError,
  IfacConferencePublicDisplay,
  IfacLoader,
} from '@ifac/ui';
import ConferencesPublic from '@/services/Api/Public/Conferences';

export default {
  name: 'ConferencesDisplay',
  components: {
    IfacConferencePublicDisplay,
    IfacLoader,
    BaseError: IfacBaseError,
  },
  data() {
    return {
      busy: false,
      error: false,
      conference: null,
    };
  },
  computed: {
    openCommittee() {
      return this.$route.query.committee || null;
    },
  },
  watch: {
    '$route.params.year': 'fetchConference',
    '$route.query.name': 'fetchConference',
  },
  mounted() {
    this.fetchConference();
  },
  methods: {
    onCommitteeChange(committee) {
      const query = { ...this.$route.query };

      if (committee) {
        query.committee = committee;
      } else {
        delete query.committee;
      }

      this.$router.replace({ query });
    },
    async fetchConference() {
      const { year } = this.$route.params;
      const { name } = this.$route.query;

      if (!year || !name) {
        this.error = true;
        return;
      }

      this.busy = true;
      this.error = false;

      try {
        const { status, data } = await ConferencesPublic.show(year, { name });

        if (status === 200) {
          this.conference = data?.data || data;
        } else {
          this.error = true;
        }
      } catch (e) {
        this.error = true;
      } finally {
        this.busy = false;
      }
    },
  },
};
</script>
